import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41d54de3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-back" }, null, -1))
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "title-text" }
const _hoisted_6 = { class: "title-text-description" }
const _hoisted_7 = { class: "sharing-card-title" }
const _hoisted_8 = { class: "sharing-card-text" }
const _hoisted_9 = { class: "sharing-card-subtitle" }
const _hoisted_10 = { class: "sharing-card-text" }
const _hoisted_11 = { class: "sharing-card-subtitle" }
const _hoisted_12 = { class: "sharing-card-title" }
const _hoisted_13 = { class: "sharing-card-text" }
const _hoisted_14 = { class: "sharing-card-subtitle" }
const _hoisted_15 = { class: "sharing-card-text" }
const _hoisted_16 = { class: "sharing-card-subtitle" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "wrapper" }
const _hoisted_19 = { class: "sharing-wrapper" }
const _hoisted_20 = { class: "left" }
const _hoisted_21 = { class: "d-aside" }
const _hoisted_22 = { class: "d-aside__main-menu" }
const _hoisted_23 = { class: "right" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-close" }, null, -1))
const _hoisted_25 = { class: "title-text" }
const _hoisted_26 = { class: "title-text-description" }
const _hoisted_27 = { class: "sharing-card-title" }
const _hoisted_28 = { class: "sharing-card-text" }
const _hoisted_29 = { class: "sharing-card-subtitle" }
const _hoisted_30 = { class: "sharing-card-text" }
const _hoisted_31 = { class: "sharing-card-subtitle" }
const _hoisted_32 = { class: "sharing-card-title" }
const _hoisted_33 = { class: "sharing-card-text" }
const _hoisted_34 = { class: "sharing-card-subtitle" }
const _hoisted_35 = { class: "sharing-card-text" }
const _hoisted_36 = { class: "sharing-card-subtitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_header = _resolveComponent("app-header")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_desktop_header = _resolveComponent("desktop-header")!
  const _component_drive_aside_main_menu = _resolveComponent("drive-aside-main-menu")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_app_header, { class: "header" }, {
            "top-left": _withCtx(() => [
              _createVNode(_component_router_link, {
                to: "/settings",
                class: "back-link"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              })
            ]),
            "top-middle": _withCtx(() => [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$localize('settings.sharing.title')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$localize('settings.sharing.description')), 1)
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_radio_group, {
            class: "sharing-card",
            modelValue: _ctx.mainStore.sharingSettings[0].allowedResharing,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mainStore.sharingSettings[0].allowedResharing) = $event)),
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateSharingSettings($event, 'allowedResharing')))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$localize('settings.sharing.re_sharing.title')), 1),
              _createVNode(_component_el_radio, {
                class: "sharing-card-item",
                label: true,
                size: "large"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$localize('settings.sharing.re_sharing.true')), 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_radio, {
                class: "sharing-card-item",
                label: false,
                size: "large"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$localize('settings.sharing.re_sharing.false')), 1)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_el_radio_group, {
            class: "sharing-card",
            modelValue: _ctx.mainStore.sharingSettings[0].allowedSave,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.mainStore.sharingSettings[0].allowedSave) = $event)),
            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateSharingSettings($event, 'allowedSave')))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$localize('settings.sharing.allow_to_save.title')), 1),
              _createVNode(_component_el_radio, {
                class: "sharing-card-item",
                label: true,
                size: "large"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$localize('settings.sharing.allow_to_save.true')), 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_radio, {
                class: "sharing-card-item",
                label: false,
                size: "large"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$localize('settings.sharing.allow_to_save.false')), 1)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_desktop_header),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("aside", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_drive_aside_main_menu)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_router_link, {
                to: "/settings",
                class: "close"
              }, {
                default: _withCtx(() => [
                  _hoisted_24
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$localize('settings.sharing.description')), 1)
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_el_radio_group, {
                  class: "sharing-card",
                  modelValue: _ctx.mainStore.sharingSettings[0].allowedResharing,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.mainStore.sharingSettings[0].allowedResharing) = $event)),
                  onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateSharingSettings($event, 'allowedResharing')))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$localize('settings.sharing.re_sharing.title')), 1),
                    _createVNode(_component_el_radio, {
                      class: "sharing-card-item",
                      label: true,
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$localize('settings.sharing.re_sharing.true')), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, {
                      class: "sharing-card-item",
                      label: false,
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$localize('settings.sharing.re_sharing.false')), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_radio_group, {
                  class: "sharing-card",
                  modelValue: _ctx.mainStore.sharingSettings[0].allowedSave,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.mainStore.sharingSettings[0].allowedSave) = $event)),
                  onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateSharingSettings($event, 'allowedSave')))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$localize('settings.sharing.allow_to_save.title')), 1),
                    _createVNode(_component_el_radio, {
                      class: "sharing-card-item",
                      label: true,
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$localize('settings.sharing.allow_to_save.true')), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, {
                      class: "sharing-card-item",
                      label: false,
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$localize('settings.sharing.allow_to_save.false')), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ])
          ])
        ])
      ]))
}